import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationBar } from 'src/services/notification.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { environment } from 'src/environment';
import { nationality, language } from 'src/models/countryModel';
import nationalitiesData from 'src/assets/nationality.json';
import languagesData from 'src/assets/languages.json';

@Component({
  selector: 'app-player-create',
  templateUrl: './player-create.component.html',
  styleUrl: './player-create.component.scss'
})
export class PlayerCreateComponent {

  teamID = "";
  workspaceID = "";
  notificationBar: NotificationBar;
  playerGroup = new FormGroup({
    nameControl: new FormControl('', [Validators.required]),
    nationalityControl: new FormControl('', [Validators.required]),
    languagesControl: new FormControl([], [Validators.required]),
  });
  isProcessing = false;
  nationalities = Array<nationality>();
  languages = Array<language>();

  constructor(public dialogRef: MatDialogRef<PlayerCreateComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private snackBar: MatSnackBar, private fireStorage: AngularFireStorage, private db: AngularFireDatabase) {
    this.notificationBar = new NotificationBar(snackBar);
    this.teamID = data.teamID;
    this.workspaceID = data.workspaceID;
  }
  
  ngOnInit() {  
    this.loadCountryInfo();
  }

  loadCountryInfo() {
    this.nationalities = Object.entries(nationalitiesData).map(([code, name]) => ({ code: code.toLocaleLowerCase(), name })).sort((a, b) => a.name.localeCompare(b.name));
    this.languages = Object.entries(languagesData).map(([code, name]) => ({ code: code.toLocaleUpperCase(), name })).sort((a, b) => a.name.localeCompare(b.name));
  }

  addPlayer() {
    var playerDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/player/');
    var newPlayerRef = playerDBRef.push();
    newPlayerRef.set({
      'name': this.playerGroup.controls.nameControl.value,
      'picture': "",
      'nationality': this.playerGroup.controls.nationalityControl.value,
      'languages': this.playerGroup.controls.languagesControl.value,
      'position': 6,
      'armrest': "on",
      'pillow': "none",
      'footrest': "no",
      'notes': "",
      'team': this.teamID
    });
    this.notificationBar.show("Player added!");
    this.dialogRef.close(newPlayerRef.key);
  }
}
